import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import PageLayout from '../../common/PageLayout'
import PageHeading from '../../common/PageHeading'
import SectionHeading from '../../common/SectionHeading'
import Divider from '../../../../../components/atoms/Divider'
import ModelsList from './ModelsList'
import GuardrailsList from './GuardrailsList'

function ModelsHome () {
  return (
    <PageLayout className='font-serif' variant='constrained'>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <PageHeading title='AI Model Catalog' />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant='body2'
            style={{
              color: 'var(--dai-color-text-low)',
              marginTop: 'var(--margin-sm)',
              marginBottom: 'var(--margin-md)',
              lineHeight: 1.6
            }}
          >
            Denali automatically selects and coordinates the right models to get the job done - maximizing performance and minimizing cost. Our intelligent routing system evaluates each request and chooses the most appropriate model based on task complexity, required capabilities, and cost efficiency. This ensures you get the best results while optimizing your usage across different model providers and pricing tiers.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <ModelsList />
        </Grid>
        <Grid item xs={12}>
          <SectionHeading title='Guardrails' size='sm' />
          <div style={{ opacity: 0.4 }}>
            <Divider />
          </div>
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant='body2'
            style={{
              color: 'var(--dai-color-text-low)',
              marginTop: 'var(--margin-sm)',
              marginBottom: 'var(--margin-md)',
              lineHeight: 1.6
            }}
          >
            Denali applies guardrails to ensure AI safety and quality across all interactions. These automated checks and filters help prevent harmful content, maintain accuracy, and enforce compliance with your organization's policies and standards.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <GuardrailsList />
        </Grid>
      </Grid>
    </PageLayout>
  )
}

export default ModelsHome
